var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2124 7.61786L17.9133 0H16.3255L10.5071 6.61448L5.85992 0H0.5L7.52738 10.0023L0.5 17.9908H2.08799L8.23237 11.0056L13.1401 17.9908H18.5L11.2121 7.61786H11.2124ZM9.03747 10.0904L8.32546 9.09439L2.66016 1.16911H5.09922L9.67118 7.56506L10.3832 8.56106L16.3262 16.8748H13.8871L9.03747 10.0908V10.0904Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.a958cb45eac7909d15de0b9d54c40b71.svg";
export { ForwardRef as ReactComponent };